import api from '@/api';
import { $deleteFileObject, $getFileObjects, $uploadFileObject } from '@/api/files/files';
import { mapFileObjectsToFileItems } from '@/api/files/files.utils';
import { FileDeleteParams, FileLoaderParams, FileObjectItem, FileUploadParams } from '@/api/files/interface';
import { isSuccessResponseStatusCode } from '@/api/handler';
import { CancelableApiResponse, IApiHandlerParams } from '@/api/interface';
import { FileListItem } from '@/components/IBFile/interface';
import { DigitalSignCommonData } from '@/mixins/crk/interface';
import ObjectUtils from '@/modules/Object/ObjectUtils';
import TimerUtils from '@/modules/Timer/TimerUtils';
import { PaymentRequirementsCardIndexDetailsItem, PaymentRequirementsCardIndexParams, PaymentRequirementsIncomingSignResponse, PaymentRequirementsItem } from './payment-requirements-incoming.interface';

export const $getPaymentRequirementsUnprocessed = async (
	handler?: IApiHandlerParams
): Promise<PaymentRequirementsItem[] | null> => {
	// await TimerUtils.sleep(500);

	// return ObjectUtils.deepCopy(
	// 	require('../__mock__/get-unprocessed.json').data
	// );

	return api
		.get('payment-requirements/get-unprocessed', { handler })
		.then(response => response || null);
};

export const $signPaymentRequirementsIncoming = async (
	body: DigitalSignCommonData
): Promise<PaymentRequirementsIncomingSignResponse | null> => {
	return api
		.post('payment-requirements/client-notified', body);
};

export const $getPaymentRequirementsCardIndexDetails = async (
	params: Partial<PaymentRequirementsCardIndexParams>,
	handler?: IApiHandlerParams
): Promise<PaymentRequirementsCardIndexDetailsItem | null> => {
	return api
		.get('payment-requirements/get-epr-info', {
			request: { params }, handler
		});
};

export const $getPaymentRequirementsFiles = async (
	body: FileLoaderParams,
): Promise<FileListItem[]> => {
	return $getFileObjects(body)
		// .then(() => ObjectUtils.deepCopy(
		// 	require('../__mock__/get-files.json').data
		// ))
		.then(mapFileObjectsToFileItems);
};

export const $uploadPaymentRequirementsFile = async (
	payload: FileUploadParams
): Promise<CancelableApiResponse<FileObjectItem | null>> => {
	return $uploadFileObject(payload);
};

export const $deletePaymentRequirementsFile = async (
	body: FileDeleteParams,
): Promise<boolean> => {
	return $deleteFileObject(body);
};

export const $refusePaymentRequirements = async (
	body: DigitalSignCommonData
) => {
	return api
		.post('payment-requirements/refusal', body, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response?.status));
};

export const $createPaymentRequirements = async (
	body: DigitalSignCommonData
) => {
	return api
		.post('payment-requirements/create-payment', body, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response?.status));
};